import { render, staticRenderFns } from "./common_popoup.vue?vue&type=template&id=2efb7b9f&scoped=true&"
import script from "./common_popoup.vue?vue&type=script&lang=js&"
export * from "./common_popoup.vue?vue&type=script&lang=js&"
import style0 from "./common_popoup.vue?vue&type=style&index=0&id=2efb7b9f&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2efb7b9f",
  null
  
)

export default component.exports